import React from "react";

/**
 * Componente para modal de confirmação de exclusão em lote
 */
const BatchDeleteModal = ({
  confirmBatchDelete,
  batchDeleteProgress,
  selectedItemsCount,
  onConfirm,
  onCancel
}) => {
  if (!confirmBatchDelete) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6">
        <h3 className="text-base font-semibold text-foreground mb-3">Confirmar Exclusão</h3>
        {!batchDeleteProgress.isDeleting ? (
          <>
            <p className="text-sm text-muted-foreground mb-5">
              Deseja realmente excluir {selectedItemsCount} item(ns)?
            </p>
            <div className="flex gap-2 justify-end">
              <button
                className="px-4 py-2 text-sm font-medium rounded-md border border-border text-foreground hover:bg-slate-50 transition-colors"
                onClick={onCancel}
              >
                Não
              </button>
              <button
                className="px-4 py-2 text-sm font-medium rounded-md bg-red-500 hover:bg-red-600 text-white transition-colors"
                onClick={onConfirm}
              >
                Sim, excluir
              </button>
            </div>
          </>
        ) : (
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground">Excluindo registros...</p>
            <div className="w-full bg-slate-100 rounded-full h-2">
              <div
                className="bg-primary h-2 rounded-full transition-all duration-300"
                style={{ width: `${(batchDeleteProgress.completed / batchDeleteProgress.total) * 100}%` }}
              />
            </div>
            <p className="text-xs text-muted-foreground">
              {batchDeleteProgress.completed} de {batchDeleteProgress.total} concluídos
            </p>
            <div className="flex gap-3 text-xs">
              <span className="text-emerald-600">Sucesso: {batchDeleteProgress.success}</span>
              {batchDeleteProgress.failed > 0 && (
                <span className="text-red-600">Falhas: {batchDeleteProgress.failed}</span>
              )}
            </div>
            {batchDeleteProgress.completed === batchDeleteProgress.total && (
              <p className="text-sm font-medium text-emerald-600">Exclusão concluída!</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BatchDeleteModal;
